import api from "./api";
import { unwrap } from "./storeService";
import { ICity, IDistrict, IPayment, VoucherType } from "../classes/interfaces";

export interface VoucherValidateRequest {
  suffix: string;
  voucherCode: string;
  orderTotal: number;
}

export interface ValidateVoucherResult {
  voucher: { id: string; code: string; type: VoucherType };
  discount: number;
}

export async function getCities(suffix: string): Promise<ICity[]> {
  const res = await api().get(`/cities/store/${suffix}`);
  return unwrap<ICity[]>(res);
}

export async function getDistricts(
  cityId: number,
  storeId: string,
): Promise<IDistrict[]> {
  const res = await api().get(`/district/city/${cityId}/${storeId}`);
  return unwrap<IDistrict[]>(res);
}

/**
 * Taxa de entrega do endereço. districtId null = sem bairro (loja que cobra por
 * distância). Loja que cobra por bairro responde 406 "district not found" quando
 * o bairro não é dela, está inativo ou não existe.
 */
export async function calculateDistance(
  storeId: string,
  location: string,
  districtId: number | null,
): Promise<{ delivery_fee: number }> {
  const res = await api().get(
    `/distance/calculate/${storeId}/${location}/${districtId}`,
  );
  return unwrap<{ delivery_fee: number }>(res);
}

export async function getPayments(suffix: string): Promise<IPayment[]> {
  const res = await api().get(`/payment?suffix=${suffix}`);
  return unwrap<IPayment[]>(res);
}

/**
 * Validates a voucher code. Unlike the other functions in this module, this does NOT
 * use unwrap() -- the caller needs the raw axios error to read
 * error.response.data.data.error for the user-facing message (same reasoning as
 * saleService.postSale not using unwrap() for its "store closed" case).
 */
export async function validateVoucher(
  data: VoucherValidateRequest,
): Promise<ValidateVoucherResult> {
  const res = await api().post("/voucher/validate", data);
  return res.data.data;
}
